import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { $auth } from 'ziphy-web-shared/basic/entities/auth';
import ChatMessageClient from '../../ChatMessageClient';
import { formatTelehealthTime } from './formatTime';
export const TelehealtAttachment = ({ consultation, message, onActionClick }) => {
    const role = $auth.role.role;
    const { t } = useTranslation();
    const userName = consultation.patient.first_name + ' ' + consultation.patient.last_name;
    const attachments = message.attachments.filter((el) => el.type === 'telehealth_appointment');
    if (!attachments.length) {
        return null;
    }
    const createMessage = (attachment) => {
        const time = formatTelehealthTime(attachment);
        let messageToSend = Object.assign(Object.assign({}, message), { attachments: [] });
        let actions = [];
        switch (attachment.status) {
            case 'created': {
                messageToSend.content =
                    message.content || `${t('label.telehealth_attachment', { userName, time })}`;
                actions = [{ type: 'add-to-calendar', data: { time } }];
                break;
            }
            case 'canceled': {
                messageToSend.content =
                    message.content || `${t('label.telehealth_attachment_canceled', { userName, time })}`;
                actions = [];
                break;
            }
            case 'finished': {
                messageToSend.content =
                    message.content || `${t('label.telehealth_attachment_finished', { userName, time })}`;
                actions = [];
                break;
            }
            default: {
                messageToSend.content =
                    message.content || `${t('label.telehealth_attachment', { userName, time })}`;
                actions = [];
                break;
            }
        }
        return {
            message: messageToSend,
            actions,
        };
    };
    return (_jsx("div", { children: attachments.map((attachment) => {
            const { message, actions } = createMessage(attachment);
            return (_jsx(ChatMessageClient, { role: role, message: message, actions: actions, onActionClick: onActionClick, showTimestamp: false }, attachment.id));
        }) }));
};
